//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

export const getIsUrlTrackingParamsEnabled = createHasFeatureSelector(
  FeatureNames.UrlTrackingParams,
);
